export default __webpack_public_path__ + "static/media/CR.6502d0a2.svg";